import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["editor", "status"]

  connect() {
    this.saveTimer = null
    this.saving = false
    this.pendingSave = false
    this.lastSavedContent = this.editorTarget.value

    this.boundVisibilityChange = this.visibilityChange.bind(this)
    document.addEventListener("visibilitychange", this.boundVisibilityChange)
  }

  disconnect() {
    document.removeEventListener("visibilitychange", this.boundVisibilityChange)
    if (this.saveTimer) clearTimeout(this.saveTimer)
    this.flushSave()
  }

  input() {
    if (this.saveTimer) clearTimeout(this.saveTimer)
    this.updateStatus("Unsaved changes", "#8C8C8C")
    this.saveTimer = setTimeout(() => this.save(), 800)
  }

  blur() {
    if (this.saveTimer) clearTimeout(this.saveTimer)
    this.save()
  }

  visibilityChange() {
    if (document.visibilityState === "hidden") {
      if (this.saveTimer) clearTimeout(this.saveTimer)
      this.flushSave()
    }
  }

  save() {
    const content = this.editorTarget.value
    if (content === this.lastSavedContent) {
      this.updateStatus("All changes saved", "#22C55E")
      return
    }

    if (this.saving) {
      this.pendingSave = true
      return
    }

    this.saving = true
    this.updateStatus("Saving...", "#8C8C8C")

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ intern_page_note: { content: content } })
    }).then(response => {
      this.saving = false
      if (response.ok) {
        this.lastSavedContent = content
        this.updateStatus("All changes saved", "#22C55E")
        if (this.pendingSave) {
          this.pendingSave = false
          this.save()
        }
      } else {
        this.updateStatus("Save failed - retrying...", "#EF4444")
        setTimeout(() => this.save(), 2000)
      }
    }).catch(() => {
      this.saving = false
      this.updateStatus("Save failed - retrying...", "#EF4444")
      setTimeout(() => this.save(), 2000)
    })
  }

  flushSave() {
    const content = this.editorTarget.value
    if (content === this.lastSavedContent) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ intern_page_note: { content: content } }),
        keepalive: true
      })
      this.lastSavedContent = content
    } catch(e) {
      // keepalive fetch failed, nothing we can do
    }
  }

  updateStatus(text, color) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = text
      this.statusTarget.style.color = color
    }
  }
}
